import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import withRouterCustom from 'utils/hoc/withRouterCustom'
import { withMixpanel } from 'utils/sdks/mixpanel'

import { isMarkOrderExportedAllowed } from 'store/currentUser/selectors'

import { withAnalytics } from './ExportDataModal.analytics'
import ExportDataModal from './ExportDataModal.component'

const mapStateToProps = (state) => ({
  allowMarkOrderExported: isMarkOrderExportedAllowed(state),
})

const withRedux = connect(mapStateToProps)

export default compose(
  withRedux,
  withRouterCustom,
  withMixpanel,
  withAnalytics,
)(ExportDataModal)
